import React, { useEffect, useState } from 'react';
import { VStack } from 'native-base';
import Section from '~/shared/Section';
import { useGeneralStyles } from '~/shared/styles';
import { AppRouteProps, useAppNavigate } from '~/pages';
import { i18nFn, useI18n } from '@springbig/shared';
import { useSpringBigStore } from '@springbig/shared';
import { WelcomeStep } from '~/pages/tenDLC/components/WelcomeStep';
import { LoginStep } from '~/pages/tenDLC/components/Login';

type ComponentProps = {
    t: i18nFn;
    onEvent: (message: string) => void;
};

export const TenDLC = () => {

    const { navigate, params } = useAppNavigate();

    const { nextStep, stashboardTarget, setWalletId } = useSpringBigStore();

    const gStyle = useGeneralStyles();
    const { t } = useI18n();

    const steps = {
        welcome: WelcomeStep,
        login: LoginStep,
    };

    const [viewportHeight, setViewportHeight] = useState<number>(window.innerHeight);

    useEffect(() => {

        const handleResize = () => {

            const height = window.innerHeight;
            setViewportHeight(height);
        };

        window.addEventListener('resize', handleResize);

        return () => {

            window.removeEventListener('resize', handleResize);
        };
    }, []);

    type Steps = 'login' | 'welcome';

    useEffect(() => {

        if (nextStep && nextStep !== 'birthday') {
            setCurrentStep(nextStep as Steps);
        }
        else {
            navigate(`w/${params.wallet_id}/`);
        }
    }, [nextStep]);

    const [currentStep, setCurrentStep] = useState<Steps>('welcome');

    const handleChildEvent = (message: string): void => {

        if (params && params.wallet_id) {
            setWalletId(params.wallet_id);
        }

        switch (message) {
            case 'messages':
                let target = stashboardTarget ? `w/${params.wallet_id}/messages/${stashboardTarget}` : `w/${params.wallet_id}/messages`;
                const plan_id = localStorage.getItem('plan_id');
                if (plan_id) {
                    localStorage.removeItem('plan_id');
                    target = `w/${params.wallet_id}/subscription/${plan_id}`;
                }

                const link_id = localStorage.getItem('link_id');
                if (link_id) {
                    localStorage.removeItem('link_id');
                    target = `w/${params.wallet_id}/subscriptions`;
                }

                navigate(target as AppRouteProps);
                break;
            case 'login':
                setCurrentStep('login');
                break;
            case 'welcome':
                setCurrentStep('welcome');
        }
    };

    return (
        <Section>
            <VStack>
                { React.createElement(
                    steps[currentStep],
                    { t, onEvent: handleChildEvent } as ComponentProps
                ) }
            </VStack>
        </Section>
    );
};
